import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef, useContext } from 'react';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import { jsx } from '@emotion/react';
import { LinkProviderContext } from '../LinkProvider/LinkProvider.js';
import { IconWrapper } from '../IconWrapper/IconWrapper.js';

const TEXT_LINK_DEFAULT_TAG = "a";
const variants = {
  standard: {
    color: "foreground.action.primary",
    ":visited": {
      color: "foreground.action.primary"
    },
    ":hover": {
      color: "foreground.action.primary.hover"
    },
    ":active": {
      color: "foreground.action.primary.active"
    },
    ":focus": {
      color: "foreground.action.primary"
    }
  },
  neutral: {
    color: "foreground.action",
    ":visited": {
      color: "foreground.action"
    },
    ":hover": {
      color: "foreground.action.hover"
    },
    ":active": {
      color: "foreground.action.active"
    },
    ":focus": {
      color: "foreground.action"
    }
  },
  inverse: {
    color: "foreground.action.inverse",
    ":visited": {
      color: "foreground.action.inverse"
    },
    ":hover": {
      color: "foreground.action.inverse.hover"
    },
    ":active": {
      color: "foreground.action.inverse.active"
    },
    ":focus": {
      color: "foreground.action.inverse"
    }
  }
};
const inlineStyles = {
  standard: {
    ":hover": {
      color: "foreground.action.primary.hover",
      bg: "background.action.hover"
    },
    ":active": {
      color: "foreground.action.primary.active",
      bg: "background.action.active"
    }
  },
  neutral: {
    ":hover": {
      color: "foreground.action.hover",
      bg: "background.action.weak.hover"
    },
    ":active": {
      color: "foreground.action.active",
      bg: "background.action.weak.active"
    }
  },
  inverse: {
    ":hover": {
      color: "foreground.action.inverse.hover",
      bg: "background.action.inverse.hover"
    },
    ":active": {
      color: "foreground.action.inverse",
      bg: "background.action.inverse.active"
    }
  }
};
const baseStyles = _ref => {
  let {
    variant = "standard",
    inline = false
  } = _ref;
  return {
    fontFamily: "default",
    textDecoration: "underline solid currentcolor 0.06em",
    textDecorationSkipInk: "none",
    textUnderlineOffset: "0.25em",
    textUnderlinePosition: "auto",
    cursor: "pointer",
    ...variants[variant],
    ...(inline && inlineStyles[variant]),
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "border-color", "background-color", "opacity", "box-shadow", "color");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    ":focus-visible": {
      outline: "none",
      boxShadow: "focus"
    }
  };
};
const StyledTextLink = /*#__PURE__*/themed(TEXT_LINK_DEFAULT_TAG, process.env.NODE_ENV === "production" ? {
  styleProps: ["variant", "inline"],
  shouldForwardProp: prop => prop !== "variant" && prop !== "inline",
  target: "e19afand0"
} : {
  styleProps: ["variant", "inline"],
  shouldForwardProp: prop => prop !== "variant" && prop !== "inline",
  target: "e19afand0",
  label: "StyledTextLink"
})(baseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/text-link
 */
const TextLink = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    children,
    iconAfter,
    ...props
  } = _ref3;
  const {
    onClick: onClickFromContext
  } = useContext(LinkProviderContext);
  return jsx(StyledTextLink, _extends({
    ref: ref,
    onClick: onClickFromContext
  }, props), children, iconAfter && jsx(IconWrapper, {
    sx: {
      display: "inline-flex",
      blockSize: "1em",
      inlineSize: "1em",
      marginBlockEnd: 1,
      marginInlineStart: 1,
      verticalAlign: "middle"
    }
  }, iconAfter));
});
const TEXT_LINK_VARIANTS = Object.keys(variants);
TextLink.displayName = "TextLink";

export { StyledTextLink, TEXT_LINK_DEFAULT_TAG, TEXT_LINK_VARIANTS, TextLink, inlineStyles };
